<template>
    <div id="header" class="animation-start">
        <div class="content">
            <router-link :to="'/' + $i18n.locale.split('-')[0]">
                <img src="../../assets/img/sternstunde-logo.png" class="ruth-logo">
            </router-link>
            <ul class="header-menu">
                <li><router-link :to="'/' + $i18n.locale.split('-')[0] + '/' + $t('header.infos')">{{$t("header.infos")}}</router-link></li>
                <li><router-link :to="'/' + $i18n.locale.split('-')[0] + '/' + $t('header.events')">{{$t("header.events")}}</router-link></li>
                <!-- <li><router-link :to="'/' + $i18n.locale.split('-')[0] + '/' + $t('header.details')">{{$t("header.details")}}</router-link></li> -->
            </ul>
            <div class="right">
              <span class="lang-link"><router-link to="/de">de</router-link></span>
              <span class="lang-link"><router-link to="/en">en</router-link></span>
              <div v-if="tickets" class="ticket-button">
                  <router-link :to="'/' + $i18n.locale.split('-')[0] + '/' + $t('header.tickets')">
                      <span>{{$t("header.tickets")}}</span>
                      <span class="glyphicon glyphicon-menu-right"></span>
                  </router-link>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "ruth-header",
  props: ["tickets"]
};
</script>

<style lang="scss">
@import "../../assets/scss/var";
#header {
  font-family: $condensed_font;
  background-color: #00284b;
  height: 85px;
  position: fixed;
  width: 100%;
  z-index: 500;
  top: 0;
  font-weight: 700;

  @include media-medium {
    padding: 0 20px;
  }

  @include media-small {
    height: 50px;
  }

  @include media-tablet {
    padding: 0 5px;
  }

  .content {
    margin: 0 auto;
    padding: 0 20px;

    .ruth-logo {
      height: 80px;
      float: left;

      @include media-small {
        height: 50px;
      }
    }

    ul {
      list-style: none;
      line-height: 85px;
      margin: 0;

      li {
        float: left;
        padding: 0 20px;

        @include media-medium {
          padding: 0 10px;
        }

        a {
          color: inherit;
          font-size: 26px;
          letter-spacing: 2px;
          text-transform: uppercase;

          @include media-medium {
            font-size: 22px;
          }
        }
      }
    }

    .right {
      position: absolute;
      right: 4px;
      display: flex;
      justify-content: flex-end;

      .lang-link {
        font-size: 20px;
        line-height: 85px;
        text-transform: uppercase;

        @include media-small {
          line-height: 50px;
          font-size: 18px;
        }

        &:first-of-type {
          padding: 0 4px;
        }

        &:not(:first-of-type) {
          padding-right: 4px;

          &::before {
            content: "|";
            padding-right: 4px;
          }
        }
      }

      .ticket-button {
        margin-left: 24px;
        margin-top: 17px;
        @include ticket_button;

        @include media-small {
          margin-top: 5px;
          height: 40px;
          font-size: 20px;
          padding: 0 6px;
          min-width: 140px;
          margin-left: 4px;
        }

        @include media-tablet {
          margin-top: 5px;
        }

        a, a:hover {
          color: inherit;
          text-decoration: none;
        }
      }
    }
  }
}

@include media-small {
  #header {
    .header-menu {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalSegments/Header.vue